import CurrencyIcon from './CurrencyIcon.vue'

export { CurrencyIcon }
export default CurrencyIcon
